import { render, staticRenderFns } from "./AutomatedResponses.vue?vue&type=template&id=261cdf12&"
import script from "./AutomatedResponses.vue?vue&type=script&lang=js&"
export * from "./AutomatedResponses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports